module.exports = __webpack_public_path__ + "static/media/12d.14b0ee8a.svg";